export const initialValues = {
  km: '',
  brand: '',
  line: '',
  version: '',
  model: '',
  color: '',
  status: '',
  subStatus: '',
  statusV2: '',
  subStatusV2: '',
  businessArea: '',
  warehouse: '',
  vehicleUuid: '',
  fuelType: '',
  transmissionType: '',
  serialNumber: '',
  plateNumber: '',
  customer: '',
  contractNumber: '',
  category: '',
};

export const initialTouched = {
  km: true,
  brand: true,
  line: true,
  version: true,
  model: true,
  color: true,
  status: true,
  subStatus: true,
  statusV2: true,
  subStatusV2: true,
  businessArea: true,
  warehouse: true,
  vehicleUuid: true,
  fuelType: true,
  transmissionType: true,
  serialNumber: true,
  plateNumber: true,
  customer: true,
  contractNumber: true,
  category: true,
};
